/** The side of a journal entry line, as core stores it on journal_entries.type. */
export enum JournalEntryLineType {
    DEBIT = 'debit',
    CREDIT = 'credit',
}
